import React from 'react';
import { LogOut } from 'lucide-react';

export default function TeacherTopSection({ teacherName, onLogout }) {
  return (
    <header className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">{teacherName}</h1>
          <p className="mt-1 text-sm text-gray-600">Teacher Dashboard</p>
        </div>
        <button
          onClick={onLogout}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          <LogOut className="mr-2 h-4 w-4" />
          Logout
        </button>
      </div>
    </header>
  );
}